import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { BackButton, Breadcrums, MUIButton } from '../../Components/Shared'
import { BREADCRUMS, PAGE_NAME } from '../../Constants'
import { showAlert } from '../../Store/Slice/alert.slice'
import { BreadcrumsModel } from '../../Models'

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  Paper,
} from '@mui/material'
import { NOTIFICATIONS } from '../../Constants/ApiDefinations'
import mainApiService from '../../Services'
import { useAppDispatch } from '../../Store/Hooks'
import './NotificationPreferences.scss'
import { logger } from '../../Helpers'

const NotificationPreferences = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  type NotificationChannel = { key: string; value: string }
  const [notificationChannels, setNotificationChannels] = useState<NotificationChannel[]>([])
  const [originalPreferences, setOriginalPreferences] = useState<Preference[]>([])

  type Event = {
    eventCode: any
    _id: string
    label: string
    channel: { [key: string]: boolean }
  }

  type Preference = {
    module: any
    _id: string
    moduleLabel: string
    events: Event[]
  }

  const [preferences, setPreferences] = useState<Preference[]>([])

  const getNotificationEvents = async () => {
    const response = await mainApiService(NOTIFICATIONS.NOTIFICATIONS_EVENT())
    setNotificationChannels(response?.data?.notificationChannels)
    setPreferences(response?.data?.preferences)
    setOriginalPreferences(response?.data?.preferences)
  }

  const isChannelChanged = (currentEvent: any, prevEvent: any) => {
    const keys = new Set([...Object.keys(currentEvent || {}), ...Object.keys(prevEvent || {})])
    for (const key of keys) {
      if (!!currentEvent[key] !== !!prevEvent[key]) return true
    }
    return false
  }
  const isEventChanged = (currentEvent: any, prevEvent: any) => {
    return isChannelChanged(currentEvent?.channel, prevEvent?.channel)
  }

  const isModuleChanged = (current: any, original: any) => {
    if (!original) return true
    return current?.events?.some((ev: any, idx: number) =>
      isEventChanged(ev, original?.events[idx]),
    )
  }
  useEffect(() => {
    getNotificationEvents()
  }, [])

  const getChangedNotifications = async () => {
    const changed = preferences
      .map((mod) => {
        const orig = originalPreferences?.find((preference) => preference?._id === mod?._id)
        if (isModuleChanged(mod, orig)) {
          return {
            module: mod?.module,
            events: mod?.events?.map((ev) => ({
              eventCode: ev?.eventCode,
              channel: ev?.channel,
            })),
          }
        }
        return null
      })
      .filter(Boolean)

    const payload = {
      configType: 'notification',
      userConfigurationId: '',
      notification: changed,
    }

    if (payload?.notification?.length > 0) {
      try {
        const response = await mainApiService(NOTIFICATIONS.USER_CONFIGURATION(payload))
        dispatch(showAlert([true, response?.message, 'success']))
        setOriginalPreferences(structuredClone(preferences))
      } catch (error) {
        logger.error(error)
      }
    }
  }
  const updatePreferencesOnChannelChange = (
    preferences: Preference[],
    prefId: string,
    eventId: string,
    channelKey: string,
    checked: boolean,
  ) => {
    return preferences.map((preference) => {
      if (preference._id !== prefId) return preference

      const updatedEvents = preference.events.map((event) => {
        if (event._id !== eventId) return event

        return {
          ...event,
          channel: {
            ...event.channel,
            [channelKey]: checked,
          },
        }
      })

      return {
        ...preference,
        events: updatedEvents,
      }
    })
  }
  const isAnyChanged = preferences?.some((mod) => {
    const orig = originalPreferences?.find((preference) => preference?._id === mod?._id)
    return isModuleChanged(mod, orig)
  })
  return (
    <div className='notif-pref__container listing-screen p-16'>
      <form action=''>
        <div className='p-8 notification-heading'>
          <Breadcrums
            isMarginTop={false}
            breadcrums={BREADCRUMS.NOTIFICATION_PREFERENCE() as BreadcrumsModel[]}
          />
        </div>
        <div className='notification-heading'>
          <BackButton
            label={PAGE_NAME.NotificationPreference}
            className='col73'
            handleOnClick={() => navigate(-1)}
          />
        </div>

        <div className='notif-pref__table-section'>
          <TableContainer component={Paper} className='notif-pref__table-header'>
            <Table>
              <TableHead>
                <TableRow className='notif-pref__header-row'>
                  <TableCell className='notif-pref__header-cell'>Permissions</TableCell>
                  {notificationChannels?.map((channel) => (
                    <TableCell
                      key={channel?.key}
                      className='notif-pref__header-cell'
                      align='center'
                    >
                      {channel?.value}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
            </Table>
          </TableContainer>

          {preferences?.map((pref) => (
            <TableContainer
              key={pref._id}
              component={Paper}
              className='notif-pref__table-container'
            >
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell
                      colSpan={1 + notificationChannels?.length}
                      className='notif-pref__module-label-cell'
                    >
                      {pref?.moduleLabel}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {pref?.events?.map((event) => (
                    <TableRow key={event._id} className='notif-pref__row'>
                      <TableCell className='notif-pref__event-label'>{event.label}</TableCell>
                      {notificationChannels?.map((channel) => (
                        <TableCell
                          key={channel.key}
                          align='center'
                          className='notif-pref__checkbox-cell'
                        >
                          <div className='notif-pref__checkbox-center'>
                            <Checkbox
                              checked={!!event.channel[channel.key]}
                              onChange={(e) => {
                                const updatedPreferences = updatePreferencesOnChannelChange(
                                  preferences,
                                  pref?._id,
                                  event?._id,
                                  channel?.key,
                                  e.target?.checked,
                                )
                                setPreferences(updatedPreferences)
                              }}
                              sx={{
                                color: '#402080',
                                '&.Mui-checked': { color: '#402080' },
                              }}
                            />
                          </div>
                        </TableCell>
                      ))}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ))}
        </div>

        <div className='submit__handler'>
          <div className='submit__handler-btn-cont listing-pref'>
            <MUIButton
              size='large'
              type='button'
              label='Submit'
              variant='contained'
              width={200}
              handleClickCB={getChangedNotifications}
              disabled={!isAnyChanged}
            />
          </div>
        </div>
      </form>
    </div>
  )
}

export default NotificationPreferences
